export const translations = {
  'es': {
    'Back': 'Atrás',
    'ALL RIGHTS RESERVED': 'TODOS LOS DERECHOS RESERVADOS',
    'Terms and conditions': 'Términos y condiciones',
    'Legal Notice': 'Aviso Legal',
    'Privacy Policy': 'Política de Privacidad',
    'Log out': 'Salir',
    'How it works': 'Cómo funciona',
    'Rewards Catalogue': 'Catálogo de premios',
    'Benefits': 'Beneficios',
    'My Area': 'Mi Area',
    'My Profile': 'Mi perfil',
    'My Bookings': 'Mis Reservas',
    'Wallet': 'Mi Billetera',
    'Catalogue': 'Catálogo',
    'Reservation Number': 'Número de Reserva',
    'Catalogue by Hotel:': 'Catálogo por hotel:',
    'Book now': 'Reserva ahora',
    'Sandos4U': 'Sandos4U',
    'Shopping Cart': 'Carrito',
    'Dashboard': 'Tablero',
    'Your Account': 'Tu Cuenta',
    'Register Account': 'Registrar cuenta',
    'Bookings': 'Reservas',
    'Coins': 'Coins',
    '{memberLevel} member': 'Miembro {memberLevel}',
    '{level} Level': 'Nivel {level}',
    'Log-in': 'Entrar',
    'or': 'o',
    'Register': 'Regístrate',
    'Register or login': 'Registrarse o acceder',
    'Booking reference': 'Código de referencia',
    'Hotel Contact': 'Contacto del Hotel',
    'Phone Number': 'Número Telefónico',
    'Email': 'Email',
    'Address': 'Dirección',
    'Contact Resort': 'Contactar con el Resort',
    'Enrich your stay': 'Enriquece tu estancia',
    '{n} room': '{n} habitación',
    '{n} rooms': '{n} habitaciones',
    '{n} adult': '{n} adulto',
    '{n} adults': '{n} adultos',
    'Select date': 'Elige una fecha',
    'required': 'Requerido',
    'Apply': 'Aplicar',
    'Analysis cookies': 'Cookies de análisis',
    'These cookies allow us to analyze and measure how you use the website to improve browsing.': 'Estas cookies nos permiten analizar y medir cómo utiliza el sitio web para mejorar la navegación.',
    'Advertising cookies': 'Cookies publicitarias',
    'Advertising companies use these cookies to publish adverts that match your interests.': 'Las empresas de publicidad utilizan estas cookies para publicar anuncios que coincidan con sus intereses.',
    'Personalization cookies': 'Cookies de personalización',
    'These cookies allow us to analyze your user profile and use of the website to give you a personalized experience.': 'Estas cookies nos permiten analizar su perfil de usuario y el uso del sitio web para brindarle una experiencia personalizada.',
    'Compulsory cookies': 'Cookies Obligatorias',
    'These cookies are essential for the website to work correctly.': 'Estas cookies son esenciales para que el sitio web funcione correctamente.',
    'We use cookies to personalize content and ads, improve your user experience, and to analyze our traffic.': 'Usamos cookies para personalizar contenido y anuncios, mejorar su experiencia de usuario y analizar nuestro tráfico.',
    'We also share information about your use of our website with our social media, advertising, and analytics partners.': 'También compartimos información sobre su uso de nuestro sitio web con nuestros socios de redes sociales, publicidad y análisis.',
    'Continue if you agree, or read more about our use of cookies here.': 'Continúe si está de acuerdo, o lea más sobre nuestro uso de cookies aquí.',
    'Configure': 'Configurar',
    'More info': 'Más info',
    'Ok, I agree': 'Ok, acepto',
    'Register your booking': 'Registrar Reserva',
    'My Bookings':'Mis Reservas',
    '{brandCode} coins are awarded for your stay that you can exchange for prizes, benefits, or discounts in future stays.': '{brandCode} coins otorgados por tu estancia que podrás canjear por premios, beneficios o descuentos en futuras estancias.',
    'Welcome free {brandCode} Coins just by signing up.': '{brandCode} Coins gratis de bienvenida sólo con registrarte.',
    'Up to 2 years of validity of your {brandCode} Coins.': 'Hasta 2 años de vigencia de tus {brandCode} Coins.',
    'Discounts on selected products and establishments.': 'Descuentos en productos y establecimientos seleccionados.',
    'My exclusive online area to access your information and be able to make movements quickly and comfortably.': 'Mi área exclusiva online para acceder a tu información y poder hacer movimientos de manera rápida y cómoda.',
    'Discounts in future stays.': 'Descuentos en futuras estancias.',
    'Benefits Spotlight': 'Beneficios destacados',
    'Resorts Mexico level Blue': 'Resorts México nivel Blue',
    'Resorts Mexico level Gold': 'Resorts México nivel Gold',
    'Resorts Spain level Blue': 'Resorts España nivel Blue',
    'Resorts Spain level Gold': 'Resorts España nivel Gold',
    'Anniversary / Just Married Band': 'Aniversario / Banda de recién casados',
    'Umbrellas': 'Paraguas',
    'Coffee or tea montage': 'Montaje de café o té',
    'Welcome snacks': 'Bocadillos de bienvenida',
    'Bathrobes': 'Albornoces',
    'Slippers': 'Zapatillas',
    'Courtesy decorative towel': 'Toalla decorativa de cortesía',
    'Romantic Courtesy': 'Cortesía romántica',
    'Assembly of soluble coffee and infusions with a Kettle': 'Ensamblaje de café soluble e infusiones con hervidor',
    'The Icing on the Cake': 'La guinda del pastel',
    'Also, besides all this, Sandos4u Blue and Gold members enjoy exclusive amenities at our hotels in Mexico and Spain just for being part of the program:': 'Además de todo esto, los socios Sandos4u Blue y Gold disfrutan de amenidades exclusivas en nuestros hoteles en México y España, sólo por estar registrados en el programa:',
    'Registration': 'en Registro',
    'Scratch': 'Scratch',
    'Code': 'Code',
    'for Stays**': 'por estancia**',
    'How to earn coins': 'Cómo ganar coins',
    'Get coins in different, easy, and fun ways and increase your balance to obtain excellent prizes, benefits, and discounts:': 'Consigue coins de diferentes maneras, fáciles y divertidas y ve aumentando tu saldo para obtener excelentes premios, beneficios y descuentos:',
    '* Only for your direct bookings.': '* Solo por tus reservas directas.',
    '* When checking out of the hotel, a return in Sandos4U Coins will be generated in favor of the Sandos4U Member who has made the reservation based on the percentage corresponding to their membership level, which will be calculated on the amount of the stay (without tax).': '* Al registro de salida del hotel, se generará a favor del Socio Sandos4U que haya realizado la reserva un retorno en Sandos4U Coins en base al porcentaje correspondiente a su nivel de membresía, mismo que será calculado sobre el importe de la estancia (sin impuesto).',
    'welcome': 'Bienvenido',
    'Join now': 'Únete ahora',
    'You are just a few clicks away from being part of our loyalty program.': 'Estás a solo unos clics de formar parte de nuestro programa de fidelización.',
    'Complete the registration form and start enjoying exclusive benefits.': 'Completa el formulario de registro y comienza a disfrutar de beneficios exclusivos.',
    'Join the club': 'Únete al club',
    'Blue': 'Blue',
    'From Registration': 'Desde el registro',
    'Amenity Blue': 'Amenidad Blue',
    'Blue discounts on extras during your stay': 'Descuentos Blue en tus extras durante la estancia',
    '5% Discount on your next direct reservation with the hotel': '5% Descuento en tu próxima reserva directa con el hotel',
    'Upgrated prize for exchange of coins.': 'Premio mejorado por canje de coins.',
    'Get products and services during your stay': 'Obtén productos y servicios durante tu estancia',
    'Gold': 'Gold',
    'For members who have stayed more than 28 nights or more than 4 stays in the last two years': 'Para miembros que en los últimos dos años se han alojado más de 28 noches o más de 4 estancias',
    'Amenity Gold': 'Amenidad Gold',
    'Gold discounts on extras during your stay': 'Descuentos Gold en tus extras durante la estancia',
    'Amenities.': 'Amenidades.',
    'Rewards to exchange with coins.': 'Premios para canjear con coins.',
    'Services to exchange with coins.': 'Servicios para canje con coins.',
    'Coins applicable for payment of stays.': 'Coins aplicables para pago de estancias.',
    'Discount on massages.': 'Descuento en masajes.',
    'Discount on wet areas.': 'Descuento en zonas húmedas.',
    'Discount on calls from room.': 'Descuento en llamadas desde habitación.',
    'Laundry discount.': 'Descuento en lavandería.',
    'Day pass discount for friends and associates.': 'Descuento de pase de un día para amigos y asociados.',
    'Discount on a la carte bottles.': 'Descuento en botellas a la carta.',
    'Discount on romantic dinners.': 'Descuento en cenas románticas.',
    'discount on water sports.': 'descuento en deportes acuáticos.',
    'Discount on jewelry': 'Descuento en joyas',
    'not all items': 'no todos los artículos',
    'Discount in hotel shops.': 'Descuento en tiendas de hotel.',
    'Discount on seek & go transportation.': 'Descuento en transporte seek & go.',
    'Discount on seek & go tours.': 'Descuento en tours seek & go.',
    'Yes.': 'Si.',
    'Private check-in and check out.': 'Check-in y check-out privados.',
    'Access to vip areas.': 'Acceso a áreas vip.',
    'VIP pools.': 'Piscinas VIP.',
    'if the hotel has them': 'si el hotel las tiene',
    'Preferential rate for black category rooms.': 'Tarifa preferencial para habitaciones de categoría Black.',
    'Preferential rate for platinum category rooms.': 'Tarifa preferencial para habitaciones categoría Platinum.',
    '10 pieces of laundry per room included.': '10 piezas de lavandería por habitación incluidas.',
    '{category} level': 'nivel {category}',
    'Benefits Table': 'Beneficios',
    'Early check-in depending on availability': 'Check-in anticipado según disponibilidad',
    'Late check-out depending on availability': 'Salida tardía según disponibilidad',
    'Exclusive products': 'Productos exclusivos',
    'Massage extension in SPA': 'Extensión de masajes en SPA',
    'Bottles of wine in restaurants': 'Botellas de vino en restaurantes',
    'Room upgrade based on availability': 'Mejora de habitación según disponibilidad',
    'Special prizes': 'Premios especiales',
    'And much more....': 'Y mucho más…',
    '{brandCode} awards for referring friends and family to the loyalty program.': 'Gana premios {brandCode} por recomendar a amigos y familiares el programa de fidelización.',
    'Better <b>Together</b>': '<b>Juntos</b> es mejor',
    '<b>{brandCode}</b> came up with the idea of rewarding your loyalty and rewarding you for choosing us. That is why we have created a program that you can access from the moment you register, and it consists of two levels. The Blue level gives you access to exclusive benefits and rewards, while the Gold level offers access to the full catalog without limitations.': '<b>{brandCode}</b> surge con la idea de premiar tu fidelidad y recompensarte por elegirnos. Es por ello que hemos creado un programa al que puedes acceder desde el mismo momento en que te registras y que consta de dos niveles. El nivel Blue te da acceso a beneficios y premios exclusivos, mientras que el nivel Gold ofrece acceso al catálogo completo sin limitaciones.',
    'Welcome to the <b>{brandName}</b> rewards program': 'Bienvenido al programa de recompensas de <b>{brandName}</b>',
    'Being a member of {brandCode} is being a part of an exclusive group of people seeking to get more out of their vacations. Access an infinite world of possibilities and benefits from the moment you register, and discover what {brandCode} has for you at its different levels.': 'Ser parte de {brandCode} es ser parte de un grupo exclusivo de personas que buscan obtener más por sus vacaciones. Accede a un mundo infinito de posibilidades y beneficios desde el mismo momento en que te registras, y ve descubriendo lo que {brandCode} tiene para ti en sus diferentes niveles.',
    'Sign up for the program through the {web} portal or at any of our hotels.': 'Regístrate en el programa a través del portal sandos4u.com o en cualquiera de nuestros hoteles.',
    'Get immediate benefits.': 'Obtén beneficios inmediatos.',
    'Get discounts on services during your stay.': 'Consigue descuentos en servicios durante tu estancia.',
    'Earn {brandCode} Coins at the check out for your direct stays.': 'Gana {brandCode} coins al check out por estancias directas.',
    'Get more {brandCode} coins through our referral program.': 'Obtén más {brandCode} coins a través de nuestro programa de referidos.',
    'Exchange {brandCode} coins for prizes during your next stay.': 'Canjea {brandCode} coins por premios para tu próxima estancia.',
    'How does it work?': '¿Cómo funciona?',
    'Your Level': 'Tu Nivel',
    'Invitation sent error': 'Erro en el envío de la invitación',
    'The invitation has already been sent.': 'La invitación ya fue enviada con anterioridad.',
    'Invitation sent': 'Enviar invitación',
    'The invitation to your friend has been sent successfully!': '¡La invitación a tu amigo ha sido enviada correctamente!',
    'Add a Friend': 'Añadir un Amigo',
    'Enter your friend\'s email address or {brandCode} number': 'Ingresa la dirección de correo electrónico de tu amigo o el número {brandCode}',
    'Thank you': 'Gracias',
    'You will receive a confirmation e-mail for you booking in less than an hour': 'Recibirás un correo electrónico de confirmación para tu reserva en menos de una hora',
    'ok, got it': 'ok, lo tengo',
    'Booking not found, give us the info we need!': 'Reserva no encontrada, ¡danos la información que necesitamos!',
    'Sorry, we can\'t find your booking.': 'Lo sentimos, no podemos encontrar su reserva.',
    'We need more info to find the booking you are looking for.': 'Necesitamos más información para encontrar la reserva que buscas.',
    'Input the following info in order to find your booking': 'Ingresa la siguiente información para encontrar tu reserva',
    'Don\'t have an account?': '¿Aún no tienes cuenta?',
    'sign up': 'registrarse',
    'You get 50 coins': 'Obtendrás 50 coins',
    'You just got {coins} coins! They will expire in {expire}. Make sure to use them before {before}': '¡Acabas de recibir {coins} coins! Expirarán en {expire}. Asegúrate de usarlos antes de {before}',
    'Redeem Code': 'Redimir Código',
    'Transaction done': 'Transacción realizada',
    'You have given {coins} coins to {friendList}!': '¡Le has dado {coins} coins a {friendList}!',
    'Error': 'Error',
    'This reservation already generated coins': 'Esta reserva ya generó coins',
    'Error while transfering the coins': 'Error al intentar trasnferir tus coins',
    'Transfer Coins': 'Transferir Coins',
    'Earn {coins} coins!': '¡Gana {coins} coins!',
    'Confirm my received invitations': 'Confirmar mis invitaciones recibidas',
    'invite a friend': 'invitar a un amigo',
    'USA': 'USA',
    'Canada': 'Canadá',
    'Argentina': 'Argentina',
    'Brazil': 'Brazil',
    'Mexico': 'México',
    'Spain & Europe': 'España & Europa',
    'UK': 'UK',
    'Others': 'Otros',
    'You are about to upgrade, hold on! Please check tomorrow if you account has been upgraded': 'Estás a punto de actualizar. Comprueba mañana si tu cuenta ha sido actualizada',
    '{nights} more night to upgrade': '{nights} noche más para actualizar',
    '{nights} more nights to upgrade': '{nights} noches más para actualizar',
    'Gift of points': 'Regalo de coins',
    'Reimbursement of points': 'Reembolso de coins',
    'Reservation': 'Reservación',
    'Create Password': 'Crear Contraseña',
    'Reset Password': 'Restablecer Contraseña',
    'Understood': 'Entendido',
    'We are making changes in our system that may affect your account information.': 'Estamos realizando ajustes en el sistema que pueden afectar a la información de tu cuenta.',
    'If you see any missed or wrong information, please contact us:': 'Si es así por favor comunícate con nosotros:',
    'for hotels in Mexico': 'para los Hoteles de México',
    'for hotels in Spain': 'para los Hoteles de España',
    'Thank you for your understanding and we are sorry for the inconvenience.': 'Lamentamos los inconvenientes y gracias por tu comprensión.',
    'Do you want to approve this friend?': '¿Quieres aprobar a este amigo?',
    'My invitations': 'Mis invitaciones',
    'Logging out': 'Cerrando sesión',
    'SIGN UP AT {brandName}': 'REGÍSTRATE EN {brandName}',
    'Please input email valid': 'Por favor inserta un correo válido',
    'Please input friend\'s email': 'Por favor inserta el correo del amigo',
    'Friend\'s email address': 'Dirección de correo del amigo',
    'Friend\'s name': 'Nombre del amigo',
    'Please input your Friend\'s name': 'Por favor inserta el nombre de tu amigo',
    'Friend\'s surname': 'Apellidos del amigo',
    'Please input your Friend\'s surname': 'Por favor inserta los apellidos de tu amigo',
    'Please input S4U number': 'Por favor inserta su miembro de S4U',
    'S4U number': 'Miembro S4U',
    'Cancel': 'Cancelar',
    'Sending...': 'Enviando...',
    'Confirm': 'Confirmar',
    'Image uploaded': 'Foto subida',
    'Error while uploading image': 'Error mientras se subía la foto',
    'Change Picture': 'Cambiar Foto',
    'Load Picture': 'Cargar Foto',
    'Password and confirm password must match!': '¡La contraseña y la contraseña de confirmación deben coincidir!',
    'Do not chars accept: #, ? and % in password': 'No se aceptan los caracteres: #, ? y % en la contraseña',
    'Password requirements': 'Requisitos de la contraseña',
    'Minimum {min} characters': 'Mínimo {min} caracteres',
    'Maximum {max} characters': 'Máximo {max} caracteres',
    'Letters, numbers and special characters are allowed': 'Se permiten letras, números y caracteres especiales',
    'The characters {chars} are not allowed': 'No se permiten los caracteres {chars}',
    'Use {min} to {max} characters. The characters {chars} are not allowed.': 'Usa entre {min} y {max} caracteres. No se permiten los caracteres {chars}.',
    'Password must be at least {min} characters': 'La contraseña debe tener al menos {min} caracteres',
    'Password cannot exceed {max} characters': 'La contraseña no puede superar los {max} caracteres',
    'The character {char} is not allowed in the password': 'El carácter {char} no está permitido en la contraseña',
    'The characters {chars} are not allowed in the password': 'Los caracteres {chars} no están permitidos en la contraseña',
    'Password reset successfully': 'Contraseña restablecida exitosamente',
    'Password updated successfully': 'Contraseña actualizada exitósamente',
    'Your link has been expired.': 'Tu enlace ha expirado.',
    'This validation link is no longer valid': 'Este enlace de validación ya no es válido',
    'The link you used is invalid or has already been used.': 'El enlace que usaste no es válido o ya fue utilizado.',
    'Your validation link has expired': 'Tu enlace de validación ha expirado',
    'Request a new link to finish your registration.': 'Solicita uno nuevo y recíbelo en tu correo electrónico para finalizar tu registro.',
    'Send new link': 'Enviar nuevo enlace',
    'Need help?': '¿Necesitas ayuda?',
    'Link sent successfully': 'Enlace enviado exitosamente',
    'Check your email.': 'Revisa tu correo electrónico.',
    'We have sent you a new link to complete your registration.': 'Te hemos enviado un nuevo enlace para completar tu registro.',
    'Type your password': 'Escribe tu contraseña',
    'Please input your password!': '¡Por favor escribe tu contraseña!',
    'Confirm your password': 'Confirma tu contraseña',
    'Please confirm your password!': '¡Por favor, confirma tu contraseña!',
    'Create': 'Crear',
    'Date of Birth': 'Fecha de Nacimiento',
    'Please rate your experience.': 'Por favor puntúa tu experiencia.',
    'Leave us a comment': 'Déjanos un comentario',
    'Comment': 'Comentario',
    'Send': 'Enviar',
    'All hotels': 'Todos los hoteles',
    'Check In': 'Entrada',
    'Hotel': 'Hotel',
    'Filter': 'Filtrar',
    'Created': 'Creado',
    'All categories': 'Todas las categorías',
    'Locator': 'Referencia de la reserva',
    'Your booking could be retrieved, please reload the page to see it.': 'Hemos localizado tu reserva, por favor recarga la página para verla.',
    'Reference code': 'Código de reserva',
    'Please input your Reference code': 'Por favor ingresa la referencia de la reserva',
    'Reservation holder\'s last name': 'Apellido del titular de la reserva',
    'Please input the reservation holder\'s last name': 'Por favor ingresa tu segundo apellido',
    'find': 'buscar',
    'Find': 'Buscar',
    'Link to reset your password has been sent to your email': 'Se ha enviado un enlace a tu dirección de email para resetear tu contraseña',
    'Failed to send you a reset link email': 'No te hemos podido enviar el enlace para resetear tu contraseña',
    'Type your Email address': 'Ingresa tu dirección de correo',
    'Please input your email!': '¡Por favor inserta tu correo electrónico!',
    'Submit': 'Enviar',
    'Please complete recaptcha': 'Por favor introduce la clave',
    'Surname': 'Apellido',
    'Please enter your surname': 'Por favor inserta tu apellido',
    'Please select Hotel': 'Selecciona el Hotel',
    'Please enter Booking reference': 'Por favor ingresa el localizado',
    'Travel agency': 'Agencia de viajes',
    'Please enter Travel agency': 'Por favor inserta la agencia de viajes',
    'Check-in': 'Entrada',
    'Please input Check-in': '¡Por favor inserta la fecha de entrada!',
    'Check-out': 'Salida',
    'Please input Check-out': '¡Por favor inserta la fecha de salida!',
    'Upload the file of your receipt...': 'Sube la confirmación de tu reserva',
    'Please upload the file': 'Por favor añade el fichero',
    'Choose a file': 'Selecciona un fichero',
    'claim booking': 'reclamar reserva',
    'Username': 'Usuario',
    'Please input your Username!': 'Por favor ingresa tu usuario',
    'Password': 'Contraseña',
    'Forgot Password?': '¿Has olvidado tu contraseña?',
    'Loading...': 'Cargando...',
    'Login': 'Ingresar',
    'Username or access e-mail': 'Nombre de usuario o correo electrónico de acceso',
    'The input is not valid E-mail!': '¡La entrada no es un correo electrónico válido!',
    'Please input your E-mail!': '¡Por favor inserta tu correo electrónico!',
    'Old Password': 'Contraseña Antigua',
    'Please input your old password!': 'Por favor ingresa tu contraseña anterior!',
    'New Password': 'Nueva Contraseña',
    'Please input your new password!': 'Por favor ingresa tu nueva contraseña!',
    'Confirm New Password': 'Confirmar Nueva Contraseña',
    'SAVE CHANGES': 'GUARDAR CAMBIOS',
    'if he edits that field, a merge will be account requested.': 'si editas este campo, se solicitará una fusión de cuenta.',
    'Edit Personal Info': 'Editar Información Personal',
    'Title': 'Título',
    'Miss.': 'Sra.',
    'Mr.': 'Sr.',
    'First Name': 'Nombre',
    'Please input your First name': 'Por favor ingresa tu nombre',
    'Last Name': 'Apellido',
    'Please input your Last name': 'Por favor ingresa tu apellido',
    'Second last name': 'Segundo apellido',
    'Please input your second last name': 'Por favor ingresa tu segundo apellido',
    'Country': 'País',
    'Select your country': 'Selecciona tu país',
    'Loading countries...': 'Cargando países...',
    'Could not load countries.': 'No se pudieron cargar los países.',
    'Try again': 'Intentar de nuevo',
    'No countries available': 'No hay países disponibles',
    'Document type': 'Tipo de documento',
    'Document number': 'Número de documento',
    'Marital status': 'Estado civil',
    'Please input your hobbies': 'Por favor ingresa tus pasatiempos',
    'Language': 'Idioma',
    'Please select your language': 'Por favor selecciona tu idioma',
    'Currency': 'Moneda',
    'If you found out about our program through one of our hotels, please select it here:': 'Si te enteraste de nuestro programa a través de uno de nuestros hoteles, selecciónalo aquí:',
    'Are you sure entered the correct code? Please check again!': '¿Estás seguro de haber ingresado el código correcto? ¡Por favor reviselo de nuevo!',
    'Oops... This code has already been used': 'Oops.. Este código ya ha sido usado',
    'Enter your code': 'Ingresa tu código',
    'Please enter your code': 'Por favor inserta tu código',
    'We sent you a confirmation email with a link to activate your account.': 'Te enviamos un correo electrónico de confirmación con un enlace para activar tu cuenta.',
    'The email is already registered': 'Este e-mail ya esta registrado',
    'Forgot your password?': '¿Has olvidado tu contraseña?',
    'Please enter a valid email address': 'Por favor ingresa un correo electrónico válido',
    'Check the email spelling and try again.': 'Revisa la escritura del correo e inténtalo de nuevo.',
    'Your registration was received, but we could not send the confirmation email.': 'Tu registro se recibió, pero no pudimos enviar el correo de confirmación.',
    'Please try again later or contact Support.': 'Inténtalo más tarde o contacta a Soporte.',
    'We could not complete your registration due to an authentication error. Please try again.': 'No pudimos completar tu registro por un error de autenticación. Inténtalo de nuevo.',
    'A merge request already exists for this account. Please contact Support.': 'Ya existe una solicitud de fusión para esta cuenta. Contacta a Soporte.',
    'We could not save your registration. Please review your data and try again.': 'No pudimos guardar tu registro. Revisa tus datos e inténtalo de nuevo.',
    'Checking email...': 'Verificando email...',
    'Could not verify this email. Please try again.': 'No se pudo verificar este email. Inténtalo de nuevo.',
    'Valid email, you can register your account with this email.': 'Email válido, puede registrar su cuenta con este email.',
    'This email has a registration in progress.': 'Este email tiene un registro en proceso.',
    'Click to receive verification email.': 'Clic para recibir email de verificación.',
    'This account was deactivated.': 'Esta cuenta fue dada de baja.',
    'Click to receive a new verification email and reactivate it.': 'Haz clic para recibir un nuevo correo de verificación y reactivarla.',
    'Click to receive verification email and reactivate account.': 'Haz clic para recibir un nuevo correo de verificación y reactivarla.',
    'This email is already registered with an active account.': 'Este email ya está registrado con una cuenta activa.',
    'Click to log in': 'Clic para entrar',
    'Click to receive password reset instructions': 'Clic para recibir instrucciones para cambio de contraseña',
    'This account has been blocked.': 'Esta cuenta ha sido bloqueada.',
    'We were unable to sign in to your account. Please contact our Support team at': 'No hemos podido iniciar sesión en tu cuenta. Contacta con el equipo de Soporte en',
    'to receive assistance.': 'para recibir asistencia.',
    'Please contact the Support team for assistance with your account.': 'Contacte al equipo de Soporte para recibir asistencia sobre su cuenta.',
    'This email is not valid or is not registered.': 'Este correo no es válido o no está registrado.',
    'Click to register': 'Clic para registrarte',
    'Incorrect password. Please try again.': 'Contraseña incorrecta. Vuelve a intentarlo.',
    'Incorrect email address or password. Please verify your information and try again.': 'Correo electrónico o contraseña incorrectos. Verifica tus datos y vuelve a intentarlo.',
    'Password reset is only available for active accounts.': 'El restablecimiento de contraseña solo está disponible para cuentas activas.',
    'Resend verification email': 'Reenviar email de verificación',
    'Failed to resend verification email': 'No se pudo reenviar el email de verificación',
    'Register with your Email address': 'Regístrate con tu dirección de correo electrónico',
    'Please input your last name': 'Por favor ingresa tu apellido',
    'Please enter your country': 'Por favor inserta tu ciudad',
    'Email': 'Email',
    'Hobbies': 'Hobbies',
    'Profile Picture': 'Foto de Perfil',
    'Load picture': 'Cargar foto',
    'Preferences': 'Preferencias',
    'PREFERENCES': 'PREFERENCIAS',
    'I agree to receive promotions from {brandName}': 'Estoy de acuerdo en recibir promociones de {brandName}',
    'Please check the conditions!': '¡Por favor, revisa las condiciones!',
    'I have read and accept the': 'He leido y acepto los',
    'Terms and Conditions': 'Términos y Condiciones',
    'Legal Notice': 'Aviso Legal',
    'and Privacy Policy of {brand}': 'y la Política de Privacidad de {brand}',
    'SENDING...': 'Enviando…',
    'Registration successfully': 'Registro',
    'Some error has occurred. Please, try again.': 'Lo sentimos, ha ocurrido un error intentando redimir...',
    'Please accept the conditions!': '¡Por favor acepta las condiciones!',
    'Our newsletter': 'Nuestro boletín',
    'Sign up today and be the first to get notified on new updates.': 'Regístrate hoy y sé el primero en recibir actualizaciones',
    'Enter your e-mail address': 'Ingresa tu dirección de correo',
    'Sending': 'Enviando...',
    'I agree to the': 'Estoy de acuerdo con las',
    'conditions': 'condiciones',
    'the coins must be a valid number!': '¡los coins deben ser un número válido!',
    'Note: you only have {coins} coins in total': 'Nota: sólo tienes {coins} coins en total',
    'Please input coins!': '¡Por favor inserta los coins!',
    'coins to a friend': 'Coins a un amigo',
    'Pick one or more friends from your friend list': 'Elige uno o más amigos de tu lista de amigos',
    'Please select your friend/s!': '¡Por favor selecciona tu amigo/s!',
    'Can\'t find a friend? Add a new one': '¿No puedes encontrar un amigo? Agregar uno nuevo',
    'Email successfully sent': 'Email enviado correctamente',
    'To verify your account, please': 'Para verificar tu cuenta, por favor',
    'click here': 'clica aquí',
    'and then check your email': 'y luego comprueba tu email',
    'No checkin bookings...': 'No hay reservas en estancia actual...',
    'enrich your stay': 'enriquece tu estancia',
    'With our best quality products': 'Con nuestros productos de la mejor calidad',
    'No reserve bookings...': 'No hay reservas futuras...',
    'Your trip is coming in {days} day': 'Tu visita es en {days} día',
    'Your trip is coming in {days} days': 'Tu visita es en {days} días',
    'No checkout bookings...': 'No hay reservas pasadas...',
    'No claimed bookings...': 'No hay reservas reclamadas...',
    'CHECKIN BOOKINGS': 'RESERVAS EN ESTANCIA ACTUAL',
    'view 5 more': 'ver 5 más',
    'RESERVE BOOKINGS': 'RESERVAS FUTURAS',
    'CHECKOUT BOOKINGS': 'RESERVAS PASADAS',
    'CLAIMED BOOKINGS': 'RESERVAS RECLAMADAS',
    'Log-in, register or become a member for better experiences!': '¡Inicia sesión, regístrate o conviértete en miembro para obtener mejores experiencias!',
    'If you want to see upcoming and past stays,': 'Si deseas ver próximas y pasadas estancias,',
    'to Sandos4U Rewards Program.': 'en el  programa de Recompensas Sandos4U.',
    'And if you become a member of the S4U Rewards Program, you can earn coins from several activities, and use them to enrich you stays!': '¡Y si te conviertes en miembro del Programa de Recompensas S4U, puedes ganar coins de varias actividades y usarlas para enriquecer tus estancias!',
    'Filter applied': 'Filtros aplicados',
    'results': 'resultados',
    'You have no bookings, yet': 'Aún no tienes reservas',
    'Find your reservation and start exchanging coins for prizes during your stay.': 'Encuentra tu reserva y comienza a canjear coins por premios durante tu estancia.',
    '* Direct reservations that are not associated with a Sandos4U Member will be associated with the first Sandos4U Member who claims them, as long as he is or has been the occupant of the reservation he intends to associate. Once associated with the Sandos4U Member, no other occupant of the reserve may claim it.': '* Las reservas directas que no estén asociadas a un miembro de Sandos4U se asignarán al primer miembro que las reclame, siempre y cuando sea o haya sido el ocupante de la habitación que desea asociar. Una vez vinculada a un miembro, no podrá ser reclamada por otro.',
    '* When checking out of the hotel, a return in Sandos4U Coins based on the percentage corresponding to their membership level will be generated only in favor of the Sandos4U Member who has claimed the reservation, which will be calculated on the amount of the stay (without tax).': '* Al hacer el check-out del hotel, se generará un reembolso en forma de Sandos4U Coins, calculado con base en el porcentaje correspondiente al nivel de membresía. Este reembolso se otorgará únicamente al miembro que haya registrado la reserva, y se basará en el monto total de la estancia antes de impuestos. Los coins acumulados pueden canjearse por premios exclusivos para miembros o utilizarse para pagar hasta el 100% de futuras estancias.',
    'Get more from Sandos!': '¡Obtén más de Sandos!',
    'Log-in or register to Sandos if you want to receive support from our Customer Care, or you need to manage your trips.': 'Inicia sesión o regístrate en Sandos si deseas recibir asistencia de nuestro servicio de atención al cliente, o si necesita administrar tus viajes.',
    'Not now, thanks': 'No ahora, gracias',
    'log-in / register': 'iniciar sesión / registrarse',
    'Photo': 'Foto',
    'Reward': 'Recompensa',
    'Quantity': 'Cantidad',
    'Nights': 'Noches',
    'Total': 'Total',
    'Sure to delete?': '¿Seguro que quieres eliminarlo?',
    'No': 'No',
    'Sorry, an error has occurred trying to redeem...': 'Lo sentimos, ha ocurrido un error intentando redimir...',
    'You don\'t have anything in your shopping cart.': 'No tienes nada en tu carrito de la compra.',
    'Continue Shopping': 'Continuar Comprando',
    'ORDER SUMMARY': 'RESUMEN DEL PEDIDO',
    'Current Coins': 'Coins Actuales',
    'Cart Total': 'Total Carrito',
    'Remaining Point Balance': 'Saldo de puntos restantes',
    'Click redeem below to pay remainder': 'Haz click en redimir a continuación para finalizar el canje',
    'Redeem': 'Redimir',
    'Congratulations!': '¡Felicidades!',
    'Thank you. We look forward to your arrival, Your reward will be waiting for you upon check-in. For any information, please contact our call center.': 'Gracias. Esperamos tu llegada, tu recompensa te estará esperando al momento del check-in. Para cualquier información, ponte en contacto con nuestro centro de llamadas.',
    'We value your feedback.': 'Valoramos tus comentarios.',
    'View all': 'Ver todo',
    'Discount': 'Descuento',
    'Prize': 'Precio',
    'Upgrade': 'Upgrade',
    'Enrich your stay with our wide range of products and services': 'Enriquece tu estancia con nuestra amplia gama de productos y servicios',
    'Welcome to': 'Bienvenid@ a',
    'RESERVATION:':'RESERVACIÓN:',
    'Your loyalty will soon have more and better rewards!': '¡Tu lealtad pronto tendrá más y mejores recompensas!',
    'At Sandos, we are working on our rewards catalog that will offer you a better experience when exchanging your Sandos4u Coins for new and great prizes.':'En Sandos estamos trabajando en nuestro catálogo de premios para que muy pronto podamos brindarte una mejor experiencia al canjear tus Sandos4u Coins por nuevos premios y de una manera rápida y sencilla.',
    'For this reason, as of Tuesday, May 30th, at Sandos Hotels in Mexico, you will not be able to view products within the prize catalog, but extremely soon, we will surprise you with an easier way to view more and better benefits.':'Es por esta razón que, a partir del martes 30 de Mayo en los hoteles de Sandos México no podrás ver ningún artículo disponible en el catálogo, sin embargo, muy pronto te sorprenderemos con más y mejores beneficios.',
    'Thank you for being part of the Sandos4u family.':'Gracias por ser parte de la familia de Sandos4u.',
    'Your current level is': 'Tu nivel actual es',
    'Claim my booking': 'Reclamar reserva',
    'Oops!': '¡Oops!',
    'We\'re sorry, but you do not currently have any registered reservations in "my bookings" section for the hotel where you pretend to collect your prize. ': 'Lo sentimos, pero actualmente no tienes ninguna reserva registrada en la sección "mis reservas" dentro del hotel en el que pretendes recoger tu premio. ',
    'Would you like to associate an existing reservation to your account or to book a new reservation?': '¿Deseas asociar una reserva existente a tu cuenta o hacer una nueva reserva ahora?',
    'Find an existing booking': 'Registrar reserva',
    'Sort by': 'Ordenar por',
    'Log-in to redeem': 'Logeate para canjear',
    'Select Level': 'Seleccionar Nivel',
    'Upgrade level required': 'Es requerido aumentar el nivel',
    'Not allowed': 'No permitido',
    'Not enough coins': 'Puntos insuficientes',
    'Checking upcoming bookings...': 'Comprobando reservas futuras…',
    'No products were found for the specified filters': 'No se han encontrado productos para los filtros indicados',
    'The prizes are delivered to the hotels; therefore, to redeem it, it is necessary to have an active reservation for the hotel to which the desired prize corresponds.': 'Los premios se entregan a los hoteles; por lo tanto, para canjearlo, es necesario tener una reserva activa para el hotel al que corresponde el premio deseado.',
    'An error has occurred adding product in cart...': 'Ha ocurrido un error añadiendo el producto en el carrito...',
    'Discounts cannot be redeemable on or after check in date': 'Los descuentos no se pueden canjear durante y/o después de la fecha de llegada.',
    'Discounts are applicable only for Direct Bookings': 'Los descuentos son aplicables solo para reservas hechas directamente en Sandos.',
    'This reward can be redeemed only for Direct Bookings.': 'Esta recompensa se puede canjear únicamente con reservas hechas directamente en Sandos.',
    'To redeem a non automatic reward type prize we need to have at least one upcoming booking': 'Para canjear un premio que requiere aprobación por nuestro equipo de soporte, necesitamos tener al menos una reserva futura.',
    'To redeem a reward type upgrade we need to have at least one upcoming booking': 'Para canjear una mejora de tipo de recompensa, debemos tener al menos una próxima reserva.',
    'To redeem this reward, the booking status should be reservation or CHECK-IN ': 'Para canjear este premio, el estado de su reserva debe ser RESERVE o CHECK-IN.',
    'To redeem this reward, the booking status should be reservation': 'Para canjear este premio, el estado su reserva debe ser RESERVE.',
    'Close': 'Cerrar',
    'Nice!': '¡Bien!',
    'Reward is being added to Cart.': 'La recompensa se ha añadido al carrito.',
    'Go to cart': 'Ir al carrito',
    'Continue shopping': 'Continuar Comprando',
    'Select Hotel': 'Selecciona el Hotel',
    'Select booking': 'Selecciona la reserva',
    'Loading your bookings...': 'Cargando sus reservas...',
    'No bookings found for this hotel': 'No se han encontrado reservas para este hotel',
    'Booking': 'Reserva',
    'Guests': 'Huéspedes',
    'Units': 'Unidades',
    'Adding product to cart...': 'Añadiendo producto al carrito...',
    'Updating catalog list. Wait a moment...': 'Actualizando catálogo. Un momento, por favor...',
    'please create your password below': 'por favor crea tu contraseña a continuación',
    'Upcoming booking': 'Próxima reserva',
    'latest stay': 'Última estancia',
    'Loading your bookings, it will take a few seconds...': 'Cargando tus reservas, sólo tardará unos segundos…',
    'see all bookings': 'ver todas las reservas',
    'Please wait while we load your profile information': 'Por favor espere mientras cargamos tu perfil de usuario',
    'Edit my profile': 'Editar mi perfil',
    'join {brandCode} as member and get access to our exclusive offers and benefits!': '¡Únete a {brandCode} como miembro y obtén acceso a nuestras ofertas y beneficios exclusivos!',
    'YOUR WALLET': 'TUS COINS',
    'Plan your next vacation!': '¡Planea tus próximas vacaciones!',
    'Don\'t miss out on our exclusive offers for you. Pick your dates for your next vacation with {brandName}.': 'No te pierdas nuestras ofertas exclusivas para ti. Elige tus fechas para tus próximas vacaciones con {brandName}.',
    'OK, book now': 'OK, reservar ahora',
    'Forgot Password': 'Olvidé mi contraseña',
    'please enter your email below': 'por favor ingresa tu email debajo',
    'Approve': 'Aprobar',
    'Here you can see your friends list. Please check if exists any pending to invite.': 'Aquí puedes ver el listado de tus amigos. Por favor revisa si tienes alguna invitación pendiente.',
    'Name': 'Nombre',
    'Status': 'Estado',
    'You must logged for see this page': 'Debes estar logrado para ver esta página',
    'Profile': 'Perfil',
    'Profile Completed': 'Perfil Completado',
    'Change password': 'Cambiar contraseña',
    'Personal Info': 'Información Personal',
    'Edit Your Info': 'Editar tu información',
    'Social Accounts': 'Redes Sociales',
    'Connected': 'Connectado',
    'disconnect': 'desconectado',
    'Connect to Facebook': 'Conectar con Facebook',
    'You are just a few clicks away from being part of our loyalty program. Fill out the registration form and start enjoying exclusive benefits.': 'Estás a solo unos clics de ser parte de nuestro programa de fidelización. Completa el formulario de registro y comienza a disfrutar de beneficios exclusivos.',
    'Download the Voucher': 'Descargar el bono',
    'Balance': 'Balance',
    'In total': 'Totales',
    'Use them': 'Úsalos',
    'redeem coins': 'redimir coins',
    'With code': 'Con el código',
    'EARN COINS': 'GANA COINS',
    'TRANSACTIONS HISTORY': 'HISTORIAL DE TRANSACCIONES',
    'Created at / Status': 'Creado en / Estado',
    'Description / Hotel': 'Descripción / Hotel',
    'Cash Paid': 'Pagar en Efectivo',
    'Use your coins': 'usa tus coins',
    'to enrich your stay': 'para enriquecer tu estancia',
    'don\'t miss out the great benefits!': '¡no te pierdas los grandes beneficios!',
    'Please complete your date of birth': 'Por favor completa tu fecha de nacimiento',
    'The date of birth you entered is invalid': 'La fecha de nacimiento introducida es inválida',
    'You must be at least 18 years old to register': 'Debes tener al menos 18 años para registrarte',
    'The year you entered is invalid': 'El año de nacimiento introducido es inválido',
    'Make sure this information matches your passport or identification document': 'Asegurate que esta información sea la misma de tu pasaporte o documento de identificación',
    'More Details': 'Más Detalles',
    'Receive account activity alerts and reservation updates by sharing this information with us':'Recibe alertas de actividad de tu cuenta y actualizaciones de tus reservaciones compartiendonos esta información',
    'Book faster by saving the profiles of your family and companions': 'Reserva más rápido guardando los perfiles de tu familia y acompañantes',
    'Additional companions': 'Acompañantes adicionales',
    'Contact': 'Contacto',
    'Emergency contact': 'Contacto de Emergencia',

    "What is Sandos4U, and what membership levels are available?":
    "¿Qué es Sandos4U y qué niveles existen?",
    "Sandos4U is the loyalty program of Sandos Hotels & Resorts, created to reward guests who book directly with us. As a member, you’ll get access to exclusive rates and the ability to earn coins and redeem them for free stays, special rewards, and premium services.":
    "Sandos4U es el programa de lealtad de Sandos Hotels & Resorts, diseñado para recompensar a los huéspedes que reservan directamente con nosotros. Al ser miembro, obtienes acceso a una tarifa preferencial, acumulación de coins, y la posibilidad de canjearlos por estancias, premios y servicios exclusivos.",
    "There are currently two membership tiers: Blue and Gold. You start at the Blue level upon registration. After staying 14 nights with us, you’ll be upgraded to Gold, unlocking enhanced perks.":
    "Actualmente existen dos niveles de membresía: Blue y Gold. Al registrarte, comienzas en el nivel Blue. Después de acumular 14 noches en Sandos, accedes al nivel Gold y desbloqueas beneficios superiores.",

    "What benefits do I get as a member?": "¿Qué beneficios obtengo como miembro?",
    "● Preferential rates based on your tier (Blue or Gold).": "● Acceso a tarifas preferenciales según tu nivel (Blue o Gold).",
    "● Coins earned for every stay.":"● Acumulación de coins por cada estancia.",
    "● Redeem Coins for exclusive rewards or hotel services.": "● Canje de coins por premios o servicios exclusivos.",
    "● Option to cover up to 100% of future stays using your Coins.":"● Posibilidad de pagar hasta el 100% de futuras estancias con tus coins.",
    
    "How do I earn coins, and how can I use them?": "¿Cómo acumulo coins y qué puedo hacer con ellos?",
    "If you booked directly with Sandos, you’ll receive a percentage of your stay’s pre-tax value as Coins when you check out, depending on your membership level. You can also earn Coins by registering past stays from up to two years ago. Gold members enjoy an even higher Coin return and receive special pricing in the rewards catalog.":
    "Si reservaste directamente con Sandos, al hacer check-out recibirás un porcentaje del valor de tu estancia antes de impuestos en forma de coins, según tu nivel de membresía. También puedes acumular coins registrando estancias pasadas de hasta 2 años atrás. Además, los miembros Gold obtienen un porcentaje mayor de coins al check-out  y precios especiales en el catálogo de recompensas.",

    "How can I see available rewards or services?":"¿Cómo sé qué premios o servicios están disponibles?",
    "Log in to your Sandos4U account under the “Catalog” section. While checked in at a hotel, you’ll see rewards available at your specific hotel. You can also visit the hotel’s Concierge Desk for assistance.":
    "Puedes consultarlos en tu cuenta de Sandos4u en la sección “Catálogo”. Cuando te encuentres en estado “check-in”, verás los productos disponibles en el hotel donde estás hospedado. O en el módulo de concierge del hotel, donde también podás resolver dudas.",

    
    "How do I claim Coins for past stays?": "¿Cómo obtener coins de estancias pasadas?",
    "You can request Coins for past reservations (up to 2 years old), even if you weren’t a Sandos4U member at the time, as long as:":
    "Puedes reclamar coins por reservas pasadas de hasta 2 años, incluso si no estabas registrado en Sandos4U al momento de la estancia, siempre que:",
    "● The booking was made directly with Sandos (not through third parties).": "● La reserva haya sido directa.",
    "● You were the primary guest or room occupant.": "● Seas el titular u ocupante de la habitación.",
    "Note: Only the first guest to register a past stay can claim the Coins.": "Nota: Solo el primer huésped que registre la estancia podrá obtener los coins.",
    "To claim Coins, go to the “My Reservations” section of your account and select “Register Reservation.” Just fill in the required information and submit.":
    "Este proceso lo puedes realizar en el módulo 'Mis reservas', sección 'Registrar reserva', completando la información solicitada.",

    "What if I have issues with my account, can’t register stays, or don’t see my Coins?":
    "¿Qué hago si tengo problemas con mi cuenta, no puedo registrar mis reservas o no veo mis coins?",


    "We’re here to help! Just email us at sandos4u.mx@sandos.com and we’ll be happy to assist you.":
    "Estamos para ayudarte. Escríbenos a sandos4u.mx@sandos.com",

    
    "¡Felicidades! Has canjeado exitosamente tu código y obtuviste ": 
    "Congratulations! You've successfully redeemed your code and received ",

    "This code has already been redeemed. Please try a different one.":
    "Este código ya ha sido canjeado anteriormente. Intenta con otro diferente.",

    "The code you entered is not valid. Please check it and try again.":
    "El código ingresado no es válido. Por favor, revise e intente nuevamente.",

    "This code has expired and can no longer be redeemed.":
    "Este código ha expirado y ya no puede ser canjeado.",

    "⚠️ We couldn't redeem this code at the moment. For assistance, please contact us at sandos4u.mx@sandos.com.":
    "⚠️ No pudimos canjear el código en este momento. Si necesitas ayuda, contáctanos en sandos4u.mx@sandos.com.",

    'VIEW MY ACTIVITY':'VER MI ACTIVIDAD',
    'YOUR LEVEL':'TU NIVEL',
    'YOUR BENEFITS': 'TUS BENEFICIOS',
    'BEST RATE GUARANTEED':'MEJOR TARIFA GARANTIZADA',
    'Unlock the best exclusive member rate':'Accede a la mejor tarifa exclusiva de miembros',
    'REDEEM COINS':'REDIME COINS',
    'Redeem your coins for amazing rewards': 'Canjea tu coins por increíbles premios',
    'EARN COINS': 'GANA COINS',
    'Earn coins with every stay': 'Acumula coins en cada estancia',

    'YOUR BOOKINGS': 'TUS RESERVAS',
    'YOUR COINS':'TUS COINS',
    'REDEEM':'REDIME',
    'MY REWARDS':'MIS PREMIOS',
    'MANAGEMENT':'ADMINISTRACIÓN',

    'Province': 'Estado/Provincia',
    'RESORTS':'HOTELES',
    'DEALS':'OFERTAS',
    'SANDOS4U':'SANDOS4U',
    'MY BOOKING':'MI RESERVA',
    'RESERVATIONS':'RESERVACIONES',
    'in the last 2 years': 'en los últimos 2 años',

    'MEXICO AND OTHERS': 'MÉXICO Y OTROS',
    'SPAIN AND EUROPE': 'ESPAÑA Y EUROPA',
    'UNITED STATES OF AMERICA': 'EEUU',
    'CANADA': 'CANADÁ',
    'ARGENTINA': 'ARGENTINA',
    'BRAZIL': 'BRASIL',
    'UNITED KINGDOM': 'REINO UNIDO',

  'Hi': 'Hola',
  'Speed ​​up your booking by saving your basic travel details': 'Acelera tu reserva guardando tus detalles básicos de viaje',
  'Find Transaction': 'Buscar Transacción',
  'Active your coins': 'Activa tus coins',
  'Use your coins to unlock great benefits': 'Usa tus Coins para obtener grandes beneficios',
  'Use Coins': 'Usar coins',
  'Do you need assistance?': '¿Necesitas asistencia?',
  'Contact us': 'Contáctanos',

  'What is Sandos4u and what membership levels are available?':
  '¿Qué es Sandos4u y qué niveles de membresía existen?',

  'Sandos4u is the loyalty programme of Sandos Hotels & Resorts Mexico, designed to reward all our guests who book directly with us. As a member, you get access to preferential rates, accumulate coins and can redeem them for stays, prizes and exclusive services.':
  'Sandos4u es el programa de lealtad de Sandos Hotels & Resorts México, diseñado para recompensar a todos nuestros huéspedes que reservan directamente con nosotros. Al ser miembro, obtienes acceso a una tarifa preferencial, acumulación de coins y la posibilidad de canjearlos por estancias, premios y servicios exclusivos.',

  'There are currently two membership levels: Blue and Gold. When you register, you start at the Blue level. After accumulating 14 nights at Sandos within a two-year period, you become a Gold member and unlock superior benefits.':
  'Actualmente existen dos niveles de membresía: Blue y Gold. Al registrarte, inicias en el nivel Blue. Después de acumular 14 noches en Sandos en un periodo de 2 años, te conviertes en miembro nivel Gold y desbloqueas beneficios superiores.',
  
  


  '•	Access to preferred rates according to your membership level.'
  :'● Acceso a tarifas preferenciales según tu nivel de membresía.',
  
  '•	Earn coins on every stay. Gold members earn a higher percentage of coins.'
  :'● Acumulación de coins por cada estancia. Los miembros Gold obtienen un porcentaje mayor de coins.',

  '•	Exchange coins for exclusive rewards or services. Gold members receive special prices in the rewards catalogue.'
  :'● Canje de coins por premios o servicios exclusivos. Los miembros Gold obtienen precios especiales en el catálogo de recompensas.',

  '•	Ability to pay up to 100% of future stays with your coins.'
  :'● Posibilidad de pagar hasta el 100% de futuras estancias con tus coins.',

  '•	Access to exclusive promotions for Sandos4u members.'
  :'● Acceso a promociones exclusivas para miembros Sandos4u.',

  
  'How do I obtain coins and what can I do with them?'
  :'¿Cómo puedo acumular coins y en qué puedo utilizarlos?',

  'If you booked directly with Sandos Hotels & Resorts and enjoyed your stay, when you check out you will receive a percentage of the value of your stay (before taxes) in the form of coins, depending on your membership level.'
  :'Si reservaste directamente con Sandos Hotels & Resorts, y disfrutaste tu estancia, al realizar el check-out recibirás un porcentaje del valor de tu estancia (antes de impuestos) en forma de coins, según tu nivel de membresía.',

  'You can also earn coins by registering past stays of up to 2 years, even if you weren’t a Sandos4u member at the time, through the “My Reservations” section—provided they were direct bookings.'
  :'También puedes obtener coins registrando tus estancias pasadas de hasta 2 años atrás, incluso si no eras miembro Sandos4u, en la sección "Mis reservas", siempre y cuando hayan sido reservas realizadas directamente con Sandos Hotels & Resorts.',
  
  'You can use the coins to pay for future stays or redeem them for exclusive rewards from the rewards catalogue.'
  :'Los coins podrás usarlos para pagar próximas estancias o canjearlos por premios exclusivos dentro del catálogo de recompensas.',
  
  'Note: Starting October 1st, 2025, Sandos hotels in Spain will no longer award coins for new bookings. Coins accumulated in your account before that date can be redeemed at Sandos hotels in Spain only until October 1st, 2027. After that date, coins can only be redeemed at Sandos hotels in Mexico.'
  :'Nota: A partir del 1 de octubre de 2025, los hoteles Sandos en España dejarán de otorgar coins por nuevas reservas. Los coins acumulados en tu cuenta hasta esa fecha podrán utilizarse para canjes en los hoteles Sandos de España únicamente hasta el 1 de octubre de 2027. Después de esa fecha, solo podrás canjearlos en los hoteles Sandos ubicados en México.',
  
  'At Sandos hotels in Mexico, both the accumulation and redemption of coins remain unchanged.'
  :'En los hoteles Sandos ubicados México, tanto la acumulación como el canje de coins se mantienen sin cambios.',


   'How can I find out what rewards or services are available and how to redeem my coins?'
  :'¿Cómo puedo saber qué premios o servicios están disponibles y cómo canjear mis coins?',

   'You can view and redeem the available rewards and services available directly from your Sandos4u account under the “Catalog” section by selecting the products of your choice.'
  :'Puedes consultar y canjear los premios y servicios disponibles directamente desde tu cuenta de Sandos4u, en la sección “Catálogo”, seleccionando los productos de tu preferencia.',

   'You can also do this at our hotel reception/concierge, they will answer any questions you may have, help you register reservations to earn coins and redeem your coins.'
  :'También puedes hacerlo con nuestra area de Concierge del hotel, donde te atenderán con cualquier duda, te ayudarán a registrar reservas para ganar coins y a realizar tus canjes.',
  
   'You can only redeem your coins once you have checked in at the hotel and your reservation appears in “check-in” status in your Sandos4u account.'
  :'Solo podrás canjear tus coins cuando hayas realizado tu check-in en el hotel y tu reserva aparezca en estado “check-in” dentro de tu cuenta Sandos4u.',


   'If your stay does not appear in this status, go to “My Reservations” > “Register Reservation”, complete the required information, and once validated, your reservation will change to “check-in”, enabling you to redeem your coins.'
  :'Si al ingresar no ves tu estancia en ese estado, accede a “Mis reservas” > “Registrar reserva”, completa la información solicitada y, una vez validada, tu reserva cambiará a “check-in”, habilitándote para realizar el canje.',


  
   'Is it possible to receive coins for previous stays?'
  :'¿Es posible recibir coins por estancia anteriores?',

  
   'You can claim coins from direct bookings made in the last 2 years, even if you weren’t a Sandos4u member at the time, as long as:'
  :'Sí es posible; puedes reclamar coins de las reservas directas realizadas en los últimos 2 años, incluso si no estabas registrado en Sandos4u, siempre que:',

  
   '•	You were the primary guest or occupant of the room.'
  :'•	Seas el titular u ocupante de la habitación.',
  
   '•	The email used at check-in matches the one in your Sandos4u account.'
  :'•	El correo electrónico de tu check-in coincida con el de tu cuenta Sandos4u.',
  
   '•	And the booking has not been previously registered.'
  :'•	Y que la reserva no se haya sido registrado previamente.',
  
   'To claim coins, go to your Sandos4u account under “My Reservations” > “Register Reservation” and complete the required information.'
  :'Para reclamar los coins, ingresa a tu cuenta Sandos4u en el módulo “Mis reservas”, sección “Registrar reserva”, y completa la información solicitada.',
  
   'If you have questions, contact sandos4u.mx@sandos.com for assistance.'
  :'Si tienes dudas, contacta a sando4u.mx@sandos.com para más información o apoyo en el proceso.',
  


   'How can I earn and redeem my coins at Sandos Hotels in Spain?'
  :'¿Cómo puedo obtener y canjear mis coins en hoteles Sandos de España?',
  
   'Since  October 1st, 2025, Sandos Hotels in Spain will have an independent loyalty program called “Más”.'
  :'Desde el 1 de octubre del 2025, los hoteles Sandos en España tienen un programa de fidelización independiente llamado "Más".',
  
   'However, you will still be able to:'
  :'Aun así, podrás:',
  
   '•	Redeem your Sandos4u coins at Sandos hotels in Spain through the Call Center until October 1st, 2027.'
  :'•	Canjear tus coins de Sandos4u en hoteles de España a través del Call Center hasta el 1 de octubre del 2027.',
  
   '•	If you made a booking in Spain before October 1st, 2025, you can claim your coins after check-out by contacting the Call Center. You have 2 years to claim them, with a final redemption date of October 1st, 2027.'
  :'•	Si realizaste una reserva en España antes del 1 de octubre de 2025, podrás reclamar tus coins una vez que hayas hecho check-out de tu estancia, contactando a nuestro Call Center. Dispones de dos años para reclamarlos, con fecha límite de canje y uso en hoteles Sandos de España hasta el 1 de octubre de 2027.',
  
   '•	If your check-out in Spain is before October 1st, 2025, you have 2 years to request and redeem your coins at Sandos hotels in Spain. The request and redemption must be completed before October 1st, 2027.'
  :'•	Si tu check-out en España es antes del 1 de octubre del 2025, cuentas con 2 años para solicitar y canjear tus coins en Hoteles Sandos de España. La solicitud y el canje deben realizarse antes del 1 de octubre de 2027.',
  
   'For more information about the new program in Spain, visit: www.sandos.es/en'
  :'Para más información sobre el nuevo programa en España visita: www.sandos.es/',


  'What should I do if I have problems with my account, cannot register my bookings, or my coins do not appear?'
  :'¿Qué debo hacer si tengo problemas con mi cuenta, no puedo registrar mis reservas o no aparecen mis coins?',

  "Don't worry, we're here to help! Write to us at sandos4u.mx@sandos.com and we'll be happy to answer your questions."
  :'No te preocupes, ¡estamos aquí para ayudarte! Escríbenos a sandos4u.mx@sandos.com y con gusto resolveremos tus dudas.',

  'For questions related to Sandos Hotels in Spain, contact us at: callcenter.eur@sandos.com'
  :'Para dudas relacionadas con los hoteles Sandos en España, contáctanos en: callcenter.eur@sandos.com',

  'Join Sandos4u': 'Únete a Sandos4u',
  'Special rate': 'Tarifa especial',
  'Save from your first booking with exclusive discounts.': 'Ahorra desde tu primera reserva con descuentos exclusivos.',
  'Earn coins': 'Gana coins',
  'Receive Coins at the end of each stay.': 'Recibe Coins al finalizar cada estancia.',
  'Redeem and enjoy': 'Canjea y disfruta',
  'Turn your Coins into stays, experiences and amazing rewards.': 'Convierte tus Coins por estancias, experiencias y premios increíbles.',
  'Sign in': 'Inicia sesión',
  'Enter your details to access your account.': 'Ingresa tus datos para acceder a tu cuenta.',
  'Email address': 'Correo electrónico',
  'Sign in now': 'Iniciar sesión',
  'Not a Sandos4u member yet?': '¿Aún no eres miembro de Sandos4u?',
  'Register now': 'Registrarse',
  'Recover password': 'Recuperar contraseña',
  'Confirm E-mail': 'Confirmar E-mail',
  'Please confirm your E-mail': 'Por favor confirma tu E-mail',
  'The emails do not match': 'Los correos electrónicos no coinciden',
  'Please input your phone number': 'Por favor ingresa tu número de teléfono',
  'Register me': 'Registrarme',
  'Join our loyalty program in just a few clicks. Complete the registration form and unlock exclusive benefits designed just for you.': 'Únete a nuestro programa de lealtad en unos pocos clics. Completa el formulario y desbloquea beneficios exclusivos pensados para ti.',
  "Don't have an account?": '¿No tienes una cuenta?',

  'Manage account': 'Gestionar cuenta',
  'You can delete or suspend your account. Clicking delete account will permanently remove your registration, data and benefits. If you prefer to suspend your account, you can reactivate it later. Suspension does not extend the validity of your benefits.':
    'Puedes eliminar o suspender tu cuenta. Si haces clic en eliminar cuenta, se eliminará de forma permanente tu registro, tus datos y tus beneficios. Si prefieres suspender tu cuenta, podrás reactivarla más adelante. La suspensión no amplía la vigencia de tus beneficios.',
  'Delete account': 'Eliminar cuenta',
  'Go back': 'Volver',
  'Are you sure you want to delete your account?': '¿Estás seguro de que quieres eliminar tu cuenta?',
  'If you prefer, you can suspend your account instead of deleting it. Suspending it keeps your registration and you can reactivate it later. Please note that the validity of your coins and membership level will continue to run as normal during the suspension.':
    'Si lo prefieres, puedes suspender tu cuenta en lugar de eliminarla. Al suspenderla conservas tu registro y podrás reactivarla más adelante. Ten en cuenta que la vigencia de tus coins y de tu nivel de membresía seguirá corriendo con normalidad durante la suspensión.',
  'Suspend': 'Suspender',
  'Delete': 'Eliminar',
  'Suspend account': 'Suspender cuenta',
  'By suspending your account you keep your registration, coins, level and benefits. You can reactivate it at any time to keep using it. Suspension does not stop the expiry period of your coins or benefits.':
    'Al suspender tu cuenta conservas tu registro, coins, nivel y beneficios. Podrás reactivarla en cualquier momento para continuar usándola. La suspensión no detiene el plazo de vigencia de tus coins ni de tus beneficios.',
  'Account suspended': 'Cuenta suspendida',
  'Your account has been suspended successfully. You can reactivate it by logging in again.':
    'Tu cuenta ha sido suspendida correctamente. Podrás reactivarla al iniciar sesión nuevamente.',
  'Log in': 'Iniciar sesión',
  'By deleting your account you will lose all benefits associated with the Sandos4u programme. Your personal data, levels, history and accumulated or pending coins will be deleted. Deletion is permanent and the information cannot be recovered, although you can register again as a new user.':
    'Al eliminar tu cuenta perderás todos los beneficios asociados al programa Sandos4u. Se eliminarán tus datos personales, niveles, historial y coins acumulados o pendientes. Esta acción es definitiva y no podrás recuperar la información, aunque podrás registrarte de nuevo como un usuario nuevo.',
  'Account deleted': 'Cuenta eliminada',
  'Your account has been deleted successfully.': 'Tu cuenta ha sido eliminada correctamente.',
  'Sorry, we could not suspend your account. Please try again later.':
    'Lo sentimos, no pudimos suspender tu cuenta. Inténtalo de nuevo más tarde.',
  'Sorry, we could not delete your account. Please try again later.':
    'Lo sentimos, no pudimos eliminar tu cuenta. Inténtalo de nuevo más tarde.',

  },
  'options': {
    'plural_rule': 'n != 1',
    'plural_number': '2',
  },
}
